import type Screen from '../api/Screen';
import GeneralComponent from '../components/GeneralComponent';

const noAvailablityMessage = 'No Tickets Available';

function render(screen: Screen, screenButtonIsSectionHeadingOnly: boolean) {
  const { isAvailable, description } = screen;
  const disabledClass = isAvailable ? '' : 'disabled';
  const disabledAttr = isAvailable ? '' : 'aria-disabled="true"';

  let headingClass = 'tn-syos-screen-button__section-heading';

  if (screenButtonIsSectionHeadingOnly) {
    headingClass += ' tn-syos-screen-button__section-heading--standalone';
  }

  return `<li class="tn-syos-screen-container__button-list-item">
    <button class="tn-syos-screen-button btn btn-primary ${disabledClass}" ${disabledAttr} aria-label="${getAriaLabel(screen)}">
      <span class="h5 ${headingClass}">${description}</span>
      ${renderButtonBody(screen)}
   </button>
  </li>`;
}

function getAriaLabel({
  description,
  isAvailable,
  priceTypeDescription,
  screenButtonShouldDisplayPriceTypeDescription,
  screenButtonShouldRenderPriceRange,
  minPriceDisplay,
  maxPriceDisplay,
}: Screen) {
  const values = [
    `${description}, `,
  ];

  if (isAvailable) {
    if (screenButtonShouldDisplayPriceTypeDescription) {
      values.push(priceTypeDescription);
    }

    if (screenButtonShouldRenderPriceRange) {
      values.push(minPriceDisplay);

      if (minPriceDisplay !== maxPriceDisplay) {
        values.push(' ');
        values.push(GeneralComponent.priceRangeSeparator);
        values.push(' ');
        values.push(maxPriceDisplay);
      }
    }
  } else {
    values.push(noAvailablityMessage);
  }

  return values.join('');
}

function renderButtonBody({
  isAvailable,
  priceTypeDescription,
  screenButtonShouldDisplayPriceTypeDescription,
  screenButtonShouldRenderPriceRange,
  minPriceDisplay,
  maxPriceDisplay,
}: Screen) {
  if (!isAvailable) {
    return `<span class="tn-syos-screen-button__message-unavailable">${noAvailablityMessage}</span>`;
  }

  const values = [];

  if (screenButtonShouldDisplayPriceTypeDescription) {
    let priceTypeLabelClass = 'tn-syos-screen-button__pricetype-label';

    if (!screenButtonShouldRenderPriceRange) {
      priceTypeLabelClass += ' tn-syos-screen-button__pricetype-label--without-price-range';
    }

    values.push(`<span class="${priceTypeLabelClass}">${priceTypeDescription}</span>`);
  }

  if (screenButtonShouldRenderPriceRange) {
    values.push(`<span class="tn-syos-screen-button__min-price">${minPriceDisplay}</span>`);

    if (minPriceDisplay !== maxPriceDisplay) {
      values.push('&nbsp;');
      values.push(`<span class="tn-syos-screen-button__separator">${GeneralComponent.priceRangeSeparator}</span>`);
      values.push('&nbsp;');
      values.push(`<span class="tn-syos-screen-button__max-price">${maxPriceDisplay}</span>`);
    }
  }

  return values.join('');
}

export default {
  render,
};
